import { useState } from "react";
import { Check, Copy } from "lucide-react";
import { toast } from "sonner";
import { copyToClipboard } from "@/lib/dom";

export default function CopyLinkButton({ url, testid }) {
  const [copied, setCopied] = useState(false);

  const handleCopy = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    const ok = await copyToClipboard(url);
    if (ok) {
      setCopied(true);
      toast.success("Link copiato — incollalo in una nuova scheda");
      setTimeout(() => setCopied(false), 2000);
      return;
    }
    toast.error("Impossibile copiare il link automaticamente.", { description: url });
  };

  return (
    <button
      type="button"
      onClick={handleCopy}
      title="Copia link Catawiki"
      aria-label="Copia link Catawiki"
      className="p-2 border border-white/15 hover:border-gold hover:text-gold text-white/70 transition-colors duration-200"
      data-testid={testid}
    >
      {copied ? <Check className="w-3.5 h-3.5" /> : <Copy className="w-3.5 h-3.5" />}
    </button>
  );
}
